export default "__VITE_ASSET__lgMevfSs__";